import { render, staticRenderFns } from "./CAP0610_pu.vue?vue&type=template&id=328ced9e&"
import script from "./CAP0610_pu.vue?vue&type=script&lang=js&"
export * from "./CAP0610_pu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports